// An italic paragraph directly under an image is its caption: smaller and
// dimmed, so it reads as part of the image rather than the article.
.markdown :global(p:has(> img) + p:has(> em:only-child)) {
	margin-top: calc(var(--mantine-spacing-md) * -0.5);
	font-size: var(--mantine-font-size-sm);
	color: var(--mantine-color-dimmed);
	line-height: 1.5;
}

// The kit's inline code style, for the code spans `MarkdownInlineCode` renders. Its
// own class name is hashed and cannot be named here.
.code-inline {
	background-color: var(--surreal-glass-subtle);
	border-radius: var(--mantine-radius-xs);
	padding: 0 var(--mantine-spacing-xs);
	border: 1px solid var(--surreal-glass-subtle);
	font-family: var(--mantine-font-family-monospace);
	font-size: 0.9em;
	font-variant-ligatures: none;
}
